export default __webpack_public_path__ + "static/media/pizza.e28b5f65.jpg";